/**
 * 绘制模块抽象类
 */

//左键取点
//移动绘制
//双击结束
//每次绘制一个，非连续绘制
import IDraw from "./IDraw"
class DrawBase extends IDraw {
    constructor(options) {
        super(options);
        options = options || {};
        this.options = options;
        this.Cesium = options.Cesium || Cesium; //Cesium对象
        this.viewer = options.viewer || viewer; //场景对象
        this.callback = options.callback; //绘制完成后回调
        this.canEdit = options.canEdit; //是否可以编辑
        this.editHelp = null;//编辑辅助类
        this.plot = null;//标绘数据
        this.entities = []; //脏数据
        this.positions = [];//关键点
        this.isStarted = false;//是否开始编辑
        this.attrPlot = {};//供编辑使用
        this.lastLeftClickTime = 0; //防止双击事件触发单击事件
    }

    //初始化关键点
    initKeyPositions() {
        //this.positions = this.removeDuplicate(this.positions); //去重
        this.plot.attrPlot = {
            edit_positions: this.positions.slice()
        }; //标绘标识
    }

    /**
     * 注册鼠标交互事件开始标绘
     */
    start() {
        if (this.isStarted) {
            return;
        }
        //重启绘制
        this.reset();
        var $this = this;
        this.handler = new this.Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);

        this.handler.setInputAction((e) => {
            var now = new Date().getTime();
            if (now - $this.lastLeftClickTime >= 250) {
                $this.leftClick(e)
            }
            $this.lastLeftClickTime = now;
        }, $this.Cesium.ScreenSpaceEventType.LEFT_CLICK);
        this.handler.setInputAction((e) => $this.mouseMove(e), $this.Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        //this.handler.setInputAction((e) => $this.leftDoubleClick(e), $this.Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        this.handler.setInputAction((e) => $this.rightClick(e), $this.Cesium.ScreenSpaceEventType.RIGHT_CLICK);
        this.isStarted = true;

    }
    //启动编辑
    startEdit() {
        this.plot.isPlotflag = this.isPlotflag;
        console.log(this.plot)
        
        if (this.editHelp && this.plot && this.canEdit) {
            this.initKeyPositions();
            this.editHelp.start(this.plot);
            this.entities.push(...this.editHelp.entities);
        }
    }

    //停止编辑
    stopEdit() {

    }

    /**
     * 从数据中加载标绘
     * @param {*} data 
     */
    loaPlot(data) {

    }

    //左键
    leftClick(evt) {
        console.log("标绘左键");
    }
    //移动事件
    mouseMove(evt) {
        console.log("标绘移动");
    }

    rightClick(evt) {
        this.leftDoubleClick(evt);
    }

    //双击
    leftDoubleClick(evt) {
        console.log("标绘双击");
        this.entitiesLabel = this.entitiesLabel || [];
        this.plot.extTag = "CL_Feature";
        this.plot.attrPlot = this.plot.attrPlot || {};
        this.plot.attrPlot["edit_keyPos"] = this.entitiesLabel;
        this.entities.push(...this.entitiesLabel);
        this.destroy();
        this.startEdit();
        this.plot.isPlotflag = this.isPlotflag;
        console.log(this.plot)
        this.callback && this.callback(this.plot);
    }

    /**
     * 销毁鼠标交互事件
     */
    destroy() {
        this.editHelp && this.editHelp.stop();
        if (this.handler) {
            this.handler.destroy();
            this.handler = null;
        }
    }

    //重置
    reset() {
        this.editHelp = null;//编辑辅助类
        this.plot = null;//标绘数据
        this.positions = [];//关键点
        this.isStarted = false;//是否开始编辑
        this.attrPlot = {};//供编辑使用
        this.lastLeftClickTime = 0;
        this.destroy(); //
    }

    /**
     * 清空实体
     */
    clear() {
        this.editHelp && this.editHelp.stop();
        this.editHelp && this.editHelp.clear();
        for (var i = 0; i < this.entities.length; i++) {
            this.viewer.entities.remove(this.entities[i]);
            if (this.entities[i].attrPlot) {
                let entities = this.entities[i].attrPlot["edit_keyPos"] || [];
                for (let i = 0; i < entities.length; i++) {
                    this.viewer.entities.remove(entities[i]);
                }
            }
        }
    }
    findById(id) {
        var has = this.entities.findIndex((row) => {
            return row.attrPlot['edit_Guid'] == id;
        });

        return has;
    }
    deleteById(id) {
        var index = this.findById(id);
        if (index >= 0) {
            var e = this.entities[index];
            this.viewer.entities.remove(e);
        }
    }

    /**
     * 实体转JSON
     */
    toJson() {
        var keyPos = this.plot.attrPlot['edit_positions'];
        var cart = this.plot.attrPlot['centerPos'];
        var data = {
            keyPos: keyPos,
            cart: cart
        }
        this.downloadJsonFile(data, '标绘.json');
    }
    downloadJsonFile(obj, fileName) {
        var data = JSON.stringify(obj);
        var blob = new Blob([data], { type: 'application/json' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.download = fileName;
        link.href = url;
        link.click();
        URL.revokeObjectURL(url);
    }

}

//导出
export default DrawBase;